<script>
import { verify4Pc, getAuthLink } from './api';

export default {
  created() {
    this.getCodeChangeToken();
  },
  methods: {
    getCodeChangeToken() {
      const { code } = this.$route.query;
      const { token } = window.sessionStorage;
      if (!token && code || token === 'undefined' && code) {
        verify4Pc({
          code
        }).then((res) => {
          if (res.code == 0) {
            window.sessionStorage.token = res.data.loginToken;
            this.$router.push({
              name: 'stage-index'
            });
          } else {
            getAuthLink({
              reUrl: window.location.href.split('?')[0]
            }).then((resTwo) => {
              if (resTwo.code == 0) {
                window.location.href = resTwo.data;
              } else {
                this.$message.error(resTwo.msg);
              }
            });
          }
        });
      } else {
        this.$router.push({
          name: 'stage-index'
        });
      }
    }
  }
};
</script>
